import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={33} height={26} fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 13h26.5M4 13L14 3M4 13l10 10" stroke="#fff" strokeWidth={5} strokeLinecap="round" /></svg>;
}
export default SvgComponent;